// extracted by mini-css-extract-plugin
export default {"dashboard_note":"dashboard-full-note_dashboard_note__xniRy","card":"dashboard-full-note_card__iM+N+","card_shadow":"dashboard-full-note_card_shadow__WrE0L"};